import { DEFAULT_VALUE_EDITOR } from '../../../constants/defaultValues';
import { USE_CASE_TYPES } from '../../Editor/Input/Tags/constants/useCaseTypes';

export const DEFAULT_BUZZ_CREATOR = {
  id: '',
  structureTags: {},
  content: {
    attachments: [],
    keyNoteTag: 'general',
    mentions: [],
    useCase: USE_CASE_TYPES.general,
    noteTags: [],
    properties: {},
    source: {
      content: DEFAULT_VALUE_EDITOR,
      type: 'html',
    },
    tags: [],
    title: '',
  },
  itemMentions: [],
  itemTags: [],
  isPublic: false,
  published: true,
  bountyCurrency: 0,
  bountyCoins: 0,
  lockedCoins: null,
  unlockPrice: null,
  summary: '',
  preSelectUseCaseOptionOfModal: '',
  useCaseInput: '',
  selectedTagsInput: '',
  selectedTags: [],
  pinnedUntil: '',
  thread: null,
};

export const DEFAULT_CREATOR_CHANNEL = {
  id: '',
  structureTags: {
    description: '',
    channelID: '',
  },
  content: {
    attachments: [],
    noteTags: ['personalData'],
    keyNoteTag: 'general',
    mentions: [],
    properties: {},
    tags: [],
    locations: [],
    topics: [],
    boosts: {},
  },
  itemMentions: [],
  itemTags: [],
  selectedTagsInput: '',
  selectedTags: [],
  isPublic: true,
};

export const DEFAULT_CREATOR_RSS_FEED = {
  id: '',
  linkId: '',
  channelId: '',
  createPrivateItem: false,
  description: DEFAULT_VALUE_EDITOR,
  metadata: {
    createdAt: null,
    createdBy: null,
    lastUpdated: null,
    locked: false,
    scrapedAt: null,
  },
  name: '',
  orgId: '',
  priority: undefined,
  streamId: null,
  tags: [],
  url: '',
};

export const DEFAULT_CREATOR_SUBSCRIPTION = {
  // to avoid uncontrolled input error
  structureTags: {
    priceCurrency: '',
    priceDuration: '',
    priceValue: '',
    priceVariationAmount: '',
    priceVariationAmountDuration: '',
    priceVariationDiscount: '',
    priceVariationDiscountDuration: '',
    priceVariationSubValue: '',
    subscriptionsName: '',
  },
  roles: [],
  moderate: false,
  content: {
    title: '',
    source: {
      content: DEFAULT_VALUE_EDITOR,
      type: 'html',
    },
  },
};

export const DEFAULT_CREATOR_COMMENT = {
  id: '',
  structureTags: {},
  content: {
    attachments: [],
    keyNoteTag: '',
    mentions: [],
    noteTags: [],
    properties: {},
    source: {
      content: DEFAULT_VALUE_EDITOR,
      type: 'html',
    },
    tags: [],
    title: '',
  },
  itemMentions: [],
  itemTags: [],
  bountyCurrency: 0,
  bountyCoins: 0,
  lockedCoins: 0,
  unlockPrice: 0,
  pinnedUntil: '',
  isPublic: true,
};
